/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_License_LInputs */

const en_wc_fact_license_l = /** @type {(inputs: Wc_Fact_License_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source you can read and audit.`)
};

/**
* | output |
* | --- |
* | "Open source you can read and audit." |
*
* @param {Wc_Fact_License_LInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_license_l = /** @type {((inputs?: Wc_Fact_License_LInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_License_LInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_license_l(inputs)
});
export { wc_fact_license_l as "wc.fact.license_l" }